import { render, staticRenderFns } from "./recharge_withdrawal.vue?vue&type=template&id=83c74158"
import script from "./recharge_withdrawal.vue?vue&type=script&lang=js"
export * from "./recharge_withdrawal.vue?vue&type=script&lang=js"
import style0 from "./recharge_withdrawal.vue?vue&type=style&index=0&id=83c74158&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports